module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "program",
    on: {
      "click": function($event) {
        return _vm.$emit('program')
      }
    }
  }, [_c('svg', {
    staticClass: "program__icon",
    attrs: {
      "height": "23",
      "viewBox": "0 0 23 23",
      "width": "23",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('path', {
    staticClass: "stroke",
    attrs: {
      "d": "m1 1h21v21h-21z",
      "stroke": "#45d374",
      "stroke-width": "2"
    }
  }), _c('g', {
    attrs: {
      "transform": "matrix(.70710678 .70710678 -.70710678 .70710678 15.035534 4.428932)"
    }
  }, [_c('path', {
    staticClass: "fill",
    attrs: {
      "d": "m0 0h5v11h-5z",
      "fill": "#45d374"
    }
  }), _c('path', {
    staticClass: "stroke",
    attrs: {
      "d": "m2.5 11.6132088 1.91361952 3.0617912h-3.82723904z",
      "stroke": "#45d374",
      "stroke-width": ".65",
      "transform": "matrix(1 0 0 -1 0 26)"
    }
  })])])]), _vm._v("Новая программа")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b619497","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/event/card/newProgramButton/NewProgramButton.vue
// module id = 644c8f529c2817db983a
// module chunks = 6